import { render, staticRenderFns } from "./SurveyAnswer.vue?vue&type=template&id=23ab2957&scoped=true&"
import script from "./SurveyAnswer.vue?vue&type=script&lang=js&"
export * from "./SurveyAnswer.vue?vue&type=script&lang=js&"
import style0 from "./SurveyAnswer.vue?vue&type=style&index=0&id=23ab2957&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ab2957",
  null
  
)

export default component.exports